
import Ventana from "../../../isp._comun/iu/_principal/reductores/Ventana";

export default class VentanaQueryContratos extends Ventana {
    constructor() {
        super();
        this.ventanaCargando = null
    }

    puedeHacersePasarPor(ventanaAAbrir) {
        if (!(ventanaAAbrir instanceof VentanaQueryContratos)) {
            return false;
        }

        return true;
    }

    clonar(){
        const nuevaVentana = new VentanaQueryContratos();
        nuevaVentana.id              = this.id;
        nuevaVentana.posicionZ       = this.posicionZ         
        nuevaVentana.ventanaCargando = this.ventanaCargando
        return nuevaVentana;
    }
}
